<template>
  <router-view />
</template>

<script>
import { mapActions } from 'vuex';

export default {
  created() {
    this.connectWebSocket(); // Call the action to establish WebSocket connection
  },
  methods: {
    ...mapActions(['connectWebSocket']),
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=DM+Mono:ital,wght@0,300;0,400;0,500;1,300;1,400;1,500&family=Inter:wght@100..900&display=swap');
html,
body {
  margin: 0;
  padding: 0;
  font-size: 10px;
}

@media (max-width: 800px) {
  html,
  body {
    font-size: 10px;
  }
  
}

.discord-user-pfp {
  /* border-radius: 50%; */

  width: 32px;

  border-radius: 50%;
}

* {
  box-sizing: border-box;
}

p {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
}

.content-header {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  margin: 0;
  font-size: 2.4rem !important;
  line-height: 29px;
  margin-bottom: 8px;
  /* identical to box height */

  color: #ffffff;
}

.delete-btn {
    cursor: pointer;
}
.delete-btn img {
    width: 24px;
}


.content-header-sub {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 150%;
  color: #bbd1d8;
  margin-bottom: 24px;
}


.modal-btn {
  display: flex;
  align-items: center;
  height: 40px;
  border-radius: 24px;
  padding: 12px 16px 12px 12px;
  font-family: 'DM Mono';
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.08em;
  text-align: center;
  border: none;
  width: 100%;
  justify-content: center;
  cursor: pointer;
}


.save-btn {
  background: #ffffff;
}


.btn {
  padding: 12px;
  font-size: 1.4rem;
  border-radius: 24px;
  background: white;
  border: none;
  font-family: 'DM Mono';
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 500;
  min-width: 170px;
  letter-spacing: 0.08em;

  color: black; /* Text color is your brand color */

  cursor: pointer;
}

.cancel-btn {
  background: linear-gradient(
      0deg,
      rgba(195, 218, 252, 0.08),
      rgba(195, 218, 252, 0.08)
    ),
    linear-gradient(0deg, rgba(195, 238, 252, 0.16), rgba(195, 238, 252, 0.16));
  border: 1px solid #c3eefc29;
  color: #bbced8;
}

.save-btn .btn-text {
  margin-left: 8px;
}


.dropdown {
  box-sizing: border-box;
  display: inline-block;
  padding: 8px 12px;
  border: 1px solid rgba(195, 238, 252, 0.16);
  border-radius: 12px;
  font-family: 'Inter';
  font-style: normal;
  width: 165px;

  font-weight: 500;
  font-size: 1.4rem;
  line-height: 150%;
  /* identical to box height, or 21px */
  color: #ffffff;
  appearance: none; /* Remove default arrow */
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path d="M12.6666 6.5L7.99992 11.1667L3.33325 6.5" stroke="white" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
  background-position: right 16px center; /* Position it 16px from the right edge */
  padding-right: 36px; /* Add padding to prevent the text from overlapping the arrow */
  cursor: pointer;
  background-color: rgba(195, 218, 252, 0.08);
}

.dropdown option {
  color: black;
}


.modal-sub-heading {
  /* COMMAND NAME */

  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 15px;
  /* identical to box height */
  letter-spacing: 0.08em;

  color: #bbced8;
  text-align: center;
}
.modal-main-heading {
  /* Add Channels */

  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 2.4rem;
  line-height: 29px;
  /* identical to box height */

  color: #ffffff;
  text-align: center;

  margin-top: 8px;
}

.modal-row {
  display: flex;
  justify-content: space-between;
}

.modal-row-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.modal-input {
  width: 165px;
  flex-direction: column;
  text-align: left;
  display: flex;
  row-gap: 4px;
  justify-content: end;
}

.label {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 15px;
  /* identical to box height */
  /* letter-spacing: 0.08em; */
  padding-left: 5px;

  color: #bbced8;
}

.input {
  background-color: rgba(195, 218, 252, 0.08);
  box-sizing: border-box;
  display: inline-block;
  padding: 8px 12px;
  border: 1px solid rgba(195, 238, 252, 0.16);
  border-radius: 12px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 150%;
  /* identical to box height, or 21px */

  color: #ffffff;
}

.input:focus,
.dropdown:focus {
  outline: none;
}

.modal-footer-content-container {
  display: flex;
  gap: 8px;
}

.required-input:after {
    content:" *";
    color: #6fe0af;
    left: 100px;
  }

  .modal-option {
  flex-direction: column;
  text-align: left;
  display: flex;
  row-gap: 4px;
}

.modal-option label {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 15px;
  /* identical to box height */
  /* letter-spacing: 0.08em; */
  padding-left: 5px;

  color: #bbced8;
}


.modal-option-input {
  background-color: rgba(195, 218, 252, 0.08);
  box-sizing: border-box;

  display: inline-block;

  padding: 8px 12px;

  border: 1px solid rgba(195, 238, 252, 0.16);
  border-radius: 12px;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 150%;
  /* identical to box height, or 21px */

  color: #ffffff;
}
.dropdown:focus,
.modal-option-input:focus {
  outline: none;
}

.modal-option-input {
  width: 165px;
}


.modal-checkbox-select {
  padding: 12px;
  border-radius: 8px;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: 'DM Mono';
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.08em;
  text-align: left;
  color: rgba(187, 206, 216, 1);
}

.search-input {
  width: 100%;
  height: 35px; /* Adjust as needed */
  padding: 0 12px;
  padding-left: 12px; /* Make room for the search icon */
  border: 1px solid rgba(195, 238, 252, 0.16);
  border-radius: 12px;
  background: linear-gradient(0deg, #101721, #101721),
    linear-gradient(0deg, rgba(195, 238, 252, 0.16), rgba(195, 238, 252, 0.16));

  color: #ffffff;
}
.search-input::placeholder {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 150%;
  /* identical to box height, or 21px */

  color: #bbd1d8;
  opacity: 0.64;
}

.search-input:focus {
  outline: none;
}
.management-container {
    background: rgba(187, 218, 255, 0.04);
    border: 1px solid rgba(187, 218, 255, 0.08);
    border-radius: 16px;
    width: 100%;
    display: flex;
    padding: 24px;
    flex-direction: column;
    row-gap: 24px;
  }


.flex-container {
  display: flex;
  gap: 24px;
}

.action-btn {
  box-sizing: border-box;
    display: inline-block;
    line-height: 150%;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
    font-family: 'DM Mono';
    font-size: 1.4em;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.08em;
    text-align: left;
    padding: 10px 12px 10px 12px;
    border-radius: 12px;
    outline: none;
    border: none;
    min-width: fit-content ;
    max-width: fit-content;

}

.modal-body {
  max-height: 350px;
  overflow-y: auto;
}

.modal-body-container {
  display: flex;
    flex-direction: column;
    row-gap: 12px;
}

.modal-body::-webkit-scrollbar {
  width: 7px;
}

/* Track */
.modal-body::-webkit-scrollbar-track {
  background: #1d2632;
  border-radius: 12px;
}

/* Handle */
.modal-body::-webkit-scrollbar-thumb {
  background: rgba(187, 218, 255, 0.04);

  border-radius: 12px;
}

/* Handle on hover */
.modal-body::-webkit-scrollbar-thumb:hover {
  background: rgba(187, 218, 255, 0.04);
}

.full-row {
  display: block !important;
}

.full-row .modal-input {
  width: 100%;
}

textarea {
  resize: none;
}

.leaflet-div-icon {
  width: 16px !important;
  height: 16px !important;
  background-color: white; /* Set the background color to white */
  border-radius: 50%; /* Make it a circle */
  border: 1px solid #ccc; /* Optional: Add a border */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Optional: Add a shadow */
  transform: translate(-50%, -50%); /* Center the icon */
  z-index: 22 !important;
}
 
.active-checked {
  background: rgba(195, 218, 252, 0.08);
}
.checkbox {
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #bbced8a3;
  border-radius: 4px;
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-label {
  min-width: 16px;
  height: 16px;
  border: 1px solid #bbced8a3;
  border-radius: 4px;
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.checkbox:checked + .checkbox-label {
  background: #42d09c3d;

  border: 2px solid #42d09ca3;
  background-image: url('data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M13.3657%204.23447C13.5157%204.3845%2013.5999%204.58794%2013.5999%204.80007C13.5999%205.0122%2013.5157%205.21565%2013.3657%205.36567L6.96568%2011.7657C6.81566%2011.9156%206.61221%2011.9999%206.40008%2011.9999C6.18795%2011.9999%205.9845%2011.9156%205.83448%2011.7657L2.63448%208.56567C2.48876%208.41479%202.40812%208.21271%202.40994%208.00295C2.41177%207.7932%202.4959%207.59255%202.64423%207.44422C2.79255%207.29589%202.9932%207.21176%203.20296%207.20993C3.41272%207.20811%203.6148%207.28875%203.76568%207.43447L6.40008%2010.0689L12.2345%204.23447C12.3845%204.0845%2012.588%204.00024%2012.8001%204.00024C13.0122%204.00024%2013.2157%204.0845%2013.3657%204.23447Z%22%20fill%3D%22%2342D09C%22%2F%3E%3C%2Fsvg%3E');
  background-repeat: no-repeat;
  background-position: center;
}

.zone-popup-content {
    font-size: 12px ;
    font-weight: 500;
    font-family: 'Inter';

  }

  .leaflet-popup-content-wrapper {
    white-space: pre-wrap;
    background: linear-gradient(0deg, #101721, #101721), linear-gradient(0deg, rgba(195, 238, 252, 0.16), rgba(195, 238, 252, 0.16));
    color: white;
    box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
}


</style>
